function parsePtBrFloat(numberString) {
  const floatNumberAsString = numberString.replace(/\./g, '').replace(',', '.').replace('R$', '').trim();
  return Number.parseFloat(floatNumberAsString);
}
export default parsePtBrFloat;